module.exports = __webpack_public_path__ + "img/图5.a23e0d46.png";